<template>
    <div class="step-indicator-simple">
        <transition-group name="step">
            <div
                v-for="step in totalSteps"
                :key="step"
                :class="getStepClass(step - 1)"
                class="step"
            ></div>
        </transition-group>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
    currentStep: number
    totalSteps: number
}>()

const getStepClass = (step: number) =>
    step <= props.currentStep ? 'active' : ''

const stepFlex = computed(() => `calc(${100 / props.totalSteps}% - 3px)`)
</script>
<style lang="scss" scoped>
.step-indicator-simple {
    display: flex;
    width: 100%;
    height: 1px;

    .step {
        height: 100%;
        flex: 0 1 0;
        transition: all 0.08s var(--timing-function-easing-emphasized-reverse);
        background-color: var(--slate);

        &.active {
            transition: all 0.12s var(--timing-function-easing-emphasized);
            flex: 0 1 calc(v-bind(stepFlex) + 3px);

            &:not(:last-of-type) {
                flex: 0 1 v-bind(stepFlex);
            }
        }

        &:not(:last-of-type) {
            margin-right: 3px;
        }
    }
}

.step-enter-active {
    transition: all 0.3s ease-out;
}

.step-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.step-enter-from,
.step-leave-to {
    transform: translateX(20px);
    opacity: 0;
}
</style>
